import { useEffect, useMemo, useRef, useState } from 'react'
import { ButtonList, PEN_ADD } from '../..'
import { ButtonTypes } from '../../../Definitions'
import { colors, glyphs } from '../../../Styles'
import { useTranslation } from 'react-i18next'

import { BaseSection } from './_Section/interface'
import { default as PEN_MOVE} from '../Pen/penMove'
import { PanelMaintainAnimal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/maintainAnimalInfoCall'
import { useAppSelector } from '../../../Store'
import { Graph_QL } from '../../../Services'
import { useAnimal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal'
import { useSection } from '../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections'

interface SectionMove_Props extends BaseSection {
  onPenClick?: (penId: number) => void
  onCancelBtn?: () => void
  onSaveBtn?: () => void
}
/**
 * SECTION_ADD
 * @param sectionId Unique identifier for each section.
 * @param onPenClick OnClick event to handle penId.
 * @param onCancelBtn OnClick event to handle Cancel btn.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_MOVE({ sectionId, onPenClick, onCancelBtn, onSaveBtn, pens }: SectionMove_Props) {
  const {t} = useTranslation()
  // const [selectedPenNo, setSelectedPenNo] = useState<number | null>(null);

  const dirtRef = useRef<PanelMaintainAnimal[]>([]);
  console.log(dirtRef.current);

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
  
  const { maintainEntries: updateAnimals } = useAnimal(connection);
  const { call: getLfSectionsInfo } = useSection(connection);
  
  function CancelBtnClick() {
    dirtRef.current = [];
    if (onCancelBtn) onCancelBtn()
  }
  
  function SaveBtnClick() {
    if (onSaveBtn) onSaveBtn()
    if (updateAnimals) {
      updateAnimals({ data: dirtRef.current }, {}, {}, ()=>(getLfSectionsInfo({ ids: [sectionId], idIdentifier: "section_id" }, connection)));
    }
    dirtRef.current = [];
  }

  // Handle Pen click
  // const handlePenClick = (penId: number) => {
  //   if (onPenClick) {
  //     onPenClick(penId);
  //     setSelectedPenNo(penId)
  //   }
  // };

  // Error throwback if no section number excists
  if (!pens.length) {
    return <div>Section {sectionId} not found</div>;
  }

  const AddModeBtns = 
  <ButtonList 
    contents={[
      t("buttons.save", {defaultValue: "save"}),
      t("buttons.cancel", {defaultValue: "cancel"}),
      t("buttons.add", {defaultValue: "add"}), 
      t("buttons.move", {defaultValue: "move"}), 
      t("buttons.edit", {defaultValue: "edit"})
    ]}
    onClick={(i => {
      if (i === 0) { SaveBtnClick() }
      if (i === 1) { CancelBtnClick() }
    })}
    buttonType={ButtonTypes.tableButton}
      startEnhancers={[
      glyphs.Check({fillColor: colors.greyDarkPrimary}),
      glyphs.Close({fillColor: colors.greyDarkPrimary}),
      glyphs.Add({fillColor: colors.greyDarkPrimary}), 
      glyphs.AnimalMove({fillColor: colors.greyDarkPrimary}), 
      glyphs.Edit({fillColor: colors.greyDarkPrimary})
    ]}
    disabled={[false, false, true, true, true]}
    overrides={(index) => ({
      baseButton: {
        backgroundColor: index === 3 ? colors.greyLightSecondary : colors.greyLightPrimary
      },
      hoverStyles: {
        backgroundColor: colors.greyLightSecondary
      },
      disabledStyles: {
        opacity: (index === 2 || index === 4) ? 0.5 : 1
      },
      contentStyles: {
        color: colors.greyDarkPrimary
      }
    })}
  />

  const renderContent = () => {
    return pens.map(pen => (
      <PEN_MOVE
        dirtyDataRef = {dirtRef}
        key={pen.location_id}
        pen={pen}
        hasHoverEffect
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "end", padding: "0px 20px" }}>
          {AddModeBtns}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "", width: "fit-content", gap: "10px", borderRadius: "10px", overflow: "hidden" }}>
          {renderContent()}
        </div>
      </div>
  );
}